module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm-tittle"
  }, [_c('span', [_vm._v("Praise for the Writing of John J. Nance")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-01"
  }, [_vm._v("“King of the modern-day aviation thriller.” —"), _c('i', [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-01"
  }, [_vm._v("“Nance is a wonderful storyteller.” —"), _c('i', [_vm._v("Chicago Tribune")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-02"
  }, [_c('span', [_c('i', [_vm._v("Final Approach")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm-01"
  }, [_vm._v("“A taut high-tech mystery that could have been written only by an airline industry insider.” —"), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author Stephen Coonts")]), _vm._v(" "), _c('p', {
    staticClass: "fm-02"
  }, [_c('span', [_c('i', [_vm._v("Scorpion Strike")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm-01"
  }, [_vm._v("“Gripping.” —"), _c('i', [_vm._v("Seattle Post")]), _vm._v("-"), _c('i', [_vm._v("Intelligencer")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-02"
  }, [_c('span', [_c('i', [_vm._v("Phoenix Rising")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm-01"
  }, [_vm._v("“Harrowing … Nance delivers suspense and smooth writing. A classy job.” —"), _c('i', [_vm._v("The New York Times Book Review")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-02"
  }, [_c('span', [_c('i', [_vm._v("Pandora")]), _vm._v("’"), _c('i', [_vm._v("s Clock")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm-01"
  }, [_vm._v("“A ticking time bomb of suspense.” —"), _c('i', [_vm._v("Chicago Tribune")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-01"
  }, [_vm._v("“A combination of "), _c('i', [_vm._v("The Hot Zone")]), _vm._v(" and "), _c('i', [_vm._v("Speed.”")]), _vm._v(" —USA Today")]), _vm._v(" "), _c('p', {
    staticClass: "fm-02"
  }, [_c('span', [_c('i', [_vm._v("Medusa’s Child")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm-01"
  }, [_vm._v("“So compelling it’s tough to look away.” —"), _c('i', [_vm._v("People")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-02"
  }, [_c('span', [_c('i', [_vm._v("The Last Hostage")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm-01"
  }, [_vm._v("“A thrilling ride … [Will] keep even the most experienced thriller addicts strapped into their seats for the whole flight.” —"), _c('i', [_vm._v("People")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-02"
  }, [_c('span', [_c('i', [_vm._v("Blackout")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm-01"
  }, [_vm._v("“A high tension, white knuckle thriller … Joltingly scary.” —"), _c('i', [_vm._v("New York Post")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-02"
  }, [_c('span', [_c('i', [_vm._v("Turbulence")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm-01"
  }, [_vm._v("“Mesmerizing in-flight details [and] a compelling cast of realistic characters … once again prove John J. Nance ‘the king of the modern-day aviation thriller’.” —"), _c('i', [_vm._v("Publishers Weekly")])]), _vm._v(" "), _c('p', {
    staticClass: "fm-02"
  }, [_c('span', [_c('i', [_vm._v("Skyhook")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm-01"
  }, [_vm._v("“Readers are in for death-defying plane rides, lively dialogue, and realistic characters who survive crises with courage and humor.” —Associated Press")]), _vm._v(" "), _c('p', {
    staticClass: "fm-02"
  }, [_c('span', [_c('i', [_vm._v("On Shaky Ground: America’s Earthquake Alert")])])]), _vm._v(" "), _c('p', {
    staticClass: "fm-01"
  }, [_vm._v("“Gripping! Breathlessly unrolls a succession of disasters.… If you want a literary equivalent of the quake experience, "), _c('i', [_vm._v("On Shaky Ground")]), _vm._v(" is the book for you.” —"), _c('i', [_vm._v("San Francisco Examiner")]), _vm._v(" & "), _c('i', [_vm._v("Chronicle")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-777a679b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frantmatter01.vue
// module id = 66
// module chunks = 0